import { SocialMedia, SocialMediaUrl } from '../emuns/enums';
import { IClientConfig } from '../interfaces/interfaces';
import { ReactComponent as FaceBookIcon } from '../assets/icons/facebook.svg';
import { ReactComponent as IsntagramIcon } from '../assets/icons/instagram.svg';
import { ReactComponent as TiktokIcon } from '../assets/icons/tiktok.svg';
import { ReactComponent as LinkdinIcon } from '../assets/icons/linkedin.svg';
import { ReactComponent as GitlabIcon } from '../assets/icons/gitlab.svg';
import { EMAIL, PHONE_NUMBER } from '../constants/constants';

// `primary: true` links surface in the header and footer. The personal
// social accounts stay in the config but off a professional portfolio —
// flip the flag if you want them back.
const ClientConfig: IClientConfig = {
    socialMedia: [
        {
            name: SocialMedia.LINKDIN,
            label: 'LinkedIn',
            url: SocialMediaUrl.LINKDIN,
            icon: <LinkdinIcon />,
            primary: true,
        },
        {
            name: SocialMedia.GITLAB,
            label: 'GitLab',
            url: SocialMediaUrl.GITLAB,
            icon: <GitlabIcon />,
            primary: true,
        },
        {
            name: SocialMedia.FACEBOOK,
            label: 'Facebook',
            url: SocialMediaUrl.FACEBOOK,
            icon: <FaceBookIcon />,
            primary: false,
        },
        {
            name: SocialMedia.INSTAGRAM,
            label: 'Instagram',
            url: SocialMediaUrl.INSTAGRAM,
            icon: <IsntagramIcon />,
            primary: false,
        },
        {
            name: SocialMedia.TIKTOK,
            label: 'TikTok',
            url: SocialMediaUrl.TIKTOK,
            icon: <TiktokIcon />,
            primary: false,
        },
    ],
    phoneNumber: PHONE_NUMBER,
    email: EMAIL,
    apiBaseHost: 'https://protfolio-server-three.vercel.app',
};

export const primarySocials = ClientConfig.socialMedia.filter((social) => social.primary);

export default ClientConfig;
